import { POST_MESSAGE_ACTION_PREFIX } from 'constants/integration';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import * as storeConstants from '../store/constants';

const SEND_ACTION_TYPE = [POST_MESSAGE_ACTION_PREFIX, types.SEND_DATA].join('/');
const RECEIVE_ACTION_TYPE = [POST_MESSAGE_ACTION_PREFIX, types.RECEIVE_DATA].join('/');

const getStatus = (data = undefined, error = undefined) => ({
  fetching: (data === undefined && error === undefined),
  data,
  error,
});

const reduceStatus = (state, id, context, value) => ({
  ...state,
  [context]: {
    [id]: value
  }
});

const reducer = (state = initialState[storeConstants.POST_MESSAGE], action) => {
  if (action.type === SEND_ACTION_TYPE) {
    const { data } = action;
    const { id, context } = data;
    return reduceStatus(state, id, context, getStatus());
  }
  if (action.type === types.CLEAR_POST_MESSAGE) {
    const { data } = action;
    const { id, context } = data;
    const rest = Object.keys(context).filter(k => k !== id).map(k => context[k]);
    return {
      ...state,
      [context]: rest
    };
  }
  if (action.type === types.POST_MESSAGE_RESPONSE) {
    const { data, meta } = action;
    const { id, context } = meta;
    return reduceStatus(state, id, context, getStatus(data.data, data.error));
  }
  if (action.type === RECEIVE_ACTION_TYPE) {
    const { data, meta, error } = action;
    const { id, context } = meta;
    return reduceStatus(state, id, context, getStatus(data, error));
  }
  return state;
};

export default reducer;
